import { useEffect, useState } from "react";
import './App.css'
import { Maincompo } from "./components/main";


function App() {


   return (
    <Maincompo />
   )
}

export default App;